import { ICheckoutAuth } from 'meta/pages/checkout'
import { ICardItem } from 'meta/pages/profile'
import { SliceSelector } from 'store/types'

const getAuth: SliceSelector<ICheckoutAuth | undefined> = () => (state) => state.pages.checkout.auth

const getConsent: SliceSelector<boolean | undefined> = () => (state) => state.pages.checkout.consent

const getFastCheckoutCreditCard: SliceSelector<ICardItem | undefined> = () => (state) =>
  state.pages.checkout.fastCheckout?.card

const getTypeTicketCollectionId: SliceSelector<string | undefined> = () => (state) =>
  state.pages.checkout.eventTypeTicketCollectionId

export const CheckoutSelectors = {
  getAuth,
  getConsent,
  getFastCheckoutCreditCard,
  getTypeTicketCollectionId,
}
